import React, { useEffect, useState } from 'react';
import { Popover, Button, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   popover: {
      boxShadow: theme.shadows[0],
      color: '#757575',
      textAlign: 'left',
      fontSize: '14px',
   },
   popoverTitle: {
      color: '#ff4d4c',
      marginBottom: theme.spacing(1),
      textAlign: 'center',
      fontSize: '14px',
      fontFamily: 'Muli-Bold',
      borderBottom: '1px solid #ebebee',
   },
   popoverContent: {
      color: '#757575',
      fontSize: '12px',
      fontWeight: 'bold',
   },
   buttonsDiv: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      marginTop: theme.spacing(2),
   },
   okayButton: {
      backgroundColor: '#2196f3',
      color: '#fff',
      padding: '4px 8px',
      fontSize: '10px',
      '&:hover': {
         backgroundColor: '#1976d2',
      },
   },
   cancelButton: {
      backgroundColor: '#4caf50',
      color: '#fff',
      padding: '4px 8px',
      fontSize: '10px',
      '&:hover': {
         backgroundColor: '#45a049',
      },
   },
   cancelpaper: {
      borderRadius: '16px',
      color: 'green',
   },
}));

const DeletePopover = ({ target = null, Id = '', onClose = () => {}, message = '' }) => {
   const popoverClasses = useStyles();
   const [DeletePopover, setDeletePopover] = useState(null);

   useEffect(() => {
      setDeletePopover(target);
   }, [target]);

   const handleOnClose = (e, action = '') => {
      setDeletePopover(() => null);
      onClose(action, Id);
   };

   const open = Boolean(DeletePopover);
   const id = open ? 'simple-popover' : undefined;
   return (
      <div>
         <Popover
            open={open}
            id={id}
            anchorEl={DeletePopover}
            anchorOrigin={{
               vertical: 'center',
               horizontal: 'center',
            }}
            transformOrigin={{
               vertical: 'center',
               horizontal: 'right',
            }}
            onClose={handleOnClose}
            classes={{ paper: popoverClasses.cancelpaper }}
         >
            <div className={`${popoverClasses.popover} cancel_confirmation_popover`} style={{ padding: '10px 15px' }}>
               <Typography variant="subtitle1" className={popoverClasses.popoverTitle}>
                  Confirmation
               </Typography>
               <Typography variant="subtitle1" className={popoverClasses.popoverContent}>
                  {message}
               </Typography>
               <Box className={popoverClasses.buttonsDiv}>
                  <Button className={popoverClasses.okayButton} onClick={(e) => handleOnClose(e, 'yes')}>
                     Yes
                  </Button>

                  <Button className={popoverClasses.cancelButton} onClick={handleOnClose}>
                     No
                  </Button>
               </Box>
            </div>
         </Popover>
      </div>
   );
};

export default DeletePopover;
